{
  "actions": {
    "switchLanguage": "מעבר לאנגלית",
    "switchTheme": "החלפת ערכת צבעים"
  },
  "auth": {
    "addPasskey": "הוספת Passkey",
    "backToSignIn": "חזרה לכניסה",
    "bootstrapEyebrow": "הגדרה ראשונית",
    "bootstrapHeading": "יצירת חשבון המנהל הראשון",
    "bootstrapSecret": "קוד ההקמה",
    "createAccount": "יצירת חשבון חדש",
    "createAccountHeading": "מצטרפים ומתחילים ליאפס.",
    "createAccountText": "כל אחד יכול להצטרף למופע הזה. ה-Passkey הוא הכניסה שלכם, בלי סיסמה.",
    "createPasskey": "יצירת Passkey והמשך",
    "displayName": "השם שלכם",
    "error": "לא הצלחנו להשלים את הפעולה. בדקו את הפרטים ונסו שוב.",
    "errorConflict": "השלב הזה כבר הושלם. נסו להתחבר במקום.",
    "errorRateLimited": "יותר מדי ניסיונות. המתינו רגע ונסו שוב.",
    "invitationEyebrow": "הוזמנתם ל-YAAPS",
    "invitationHeading": "הגדרת החשבון שלכם",
    "loading": "בודקים אם אתם כבר מחוברים...",
    "orRecovery": "או נכנסים עם קוד שחזור",
    "passkeyAdded": "ה-Passkey נוסף.",
    "recoveryCode": "קוד שחזור",
    "recoveryCodesHeading": "שמרו את קודי השחזור",
    "recoveryCodesWarning": "כל קוד עובד פעם אחת. לא תוכלו לראות אותם שוב.",
    "regenerateRecoveryCodes": "יצירת קודי שחזור חדשים",
    "regenerateRecoveryCodesConfirm": "החלפת הקודים",
    "regenerateRecoveryCodesWarning": "קודי השחזור שלא נוצלו יפסיקו לעבוד ברגע שייווצרו חדשים.",
    "registerEyebrow": "יצירת חשבון",
    "registerHeading": "מצטרפים ומתחילים ליאפס.",
    "roleAdmin": "חשבון מנהל",
    "roleUser": "חשבון משתמש",
    "savedRecoveryCodes": "שמרתי את הקודים",
    "signInEyebrow": "טוב שחזרתם",
    "signInHeading": "כניסה ל-YAAPS",
    "signInWithPasskey": "כניסה עם Passkey",
    "signOut": "יציאה",
    "signedInEyebrow": "החשבון שלכם",
    "useRecoveryCode": "כניסה עם קוד שחזור",
    "working": "רק רגע..."
  },
  "connect": {
    "approve": "אישור החיבור",
    "approveWarning": "אשרו רק אם התחלתם את החיבור הזה בעצמכם ממש עכשיו במכשיר שלכם. השם המוצג נמסר על ידי המבקש ואינו מאומת.",
    "approvedHeading": "הסוכן חובר",
    "approvedText": "הבקשה החד-פעמית אושרה. חזרו לסוכן כדי להמשיך.",
    "askHeading": "מבקשים מה-AI להתחבר",
    "askPrompt": "Connect to YAAPS",
    "askText": "פותחים את ה-AI ושולחים לו את הבקשה הקצרה הזו. הוא יציג קוד חד-פעמי או יפתח את העמוד הזה לאישור.",
    "automaticTargets": "הסקריפט מזהה את Codex ואת Claude ומתקין את הסקיל לכל התקנה שהוא מוצא. אם אף אחד מהם לא מזוהה, הוא מתקין בשני הנתיבים הרגילים.",
    "claudeDetail": "מתקינים את אותו סקיל נייד עבור Claude.",
    "claudeName": "Claude",
    "clientLabel": "הסוכן שמבקש להתחבר",
    "codeHelp": "הזינו את הקוד החד-פעמי שמוצג אצל הסוכן.",
    "codeLabel": "קוד חיבור",
    "codePlaceholder": "ABCD-EFGH",
    "codexDetail": "מתקינים את הסקיל YAAPS עבור Codex.",
    "codexName": "Codex",
    "commandIntro": "מעתיקים את הפקודה ומריצים אותה ב-Terminal:",
    "continueToApproval": "המשך לאישור",
    "copied": "הועתק",
    "copyCommand": "העתקת הפקודה",
    "copyFailed": "הדפדפן חסם את ההעתקה. סמנו את הטקסט והעתיקו אותו ידנית.",
    "copyPrompt": "העתקת הבקשה",
    "decided": "בקשת החיבור הזו כבר אושרה או נדחתה. התחילו חיבור חדש מתוך הסוכן.",
    "deniedHeading": "החיבור נדחה",
    "deniedText": "הבקשה החד-פעמית נדחתה. הסוכן לא קיבל גישה.",
    "deny": "דחיית החיבור",
    "downloadSkill": "הורדת הסקיל YAAPS כ-ZIP",
    "expired": "פג התוקף של בקשת החיבור. התחילו חיבור חדש מתוך הסוכן.",
    "expires": "בתוקף עד",
    "genericDestination": "תיקיית ה-Skills שמוגדרת ב-AI שלכם",
    "genericDetail": "משתמשים ב-YAAPS עם AI אחר שתומך ב-Agent Skills.",
    "genericName": "AI אחר עם Agent Skills",
    "heading": "מוסיפים את YAAPS ל-AI בשלושה צעדים",
    "installHeading": "איך רוצים להתקין?",
    "intro": "מתקינים את הסקיל הנייד, מבקשים מה-AI להתחבר ומאשרים כאן. לא צריך npm, תוכנת exe או התקנת CLI, ואין מפתח API שצריך ליצור או להדביק.",
    "invalid": "לא מצאנו בקשה פעילה עבור הקוד הזה. בדקו אותו ונסו שוב.",
    "lookup": "בדיקת הבקשה",
    "manualContinue": "התקנתי את הסקיל, ממשיכים",
    "manualCopy": "מעתיקים את התיקייה yaaps שחולצה אל",
    "manualExtract": "מחלצים את קובץ ה-ZIP שהורד.",
    "methodHeading": "בחירת שיטת התקנה",
    "methodNames": {
      "macos": "macOS",
      "manual": "ידנית",
      "windows": "Windows"
    },
    "pendingHeading": "אישור החיבור",
    "pendingText": "אשרו רק אם התחלתם את הבקשה ב-AI שמוצג כאן. האישור מאפשר לו לפרסם ולנהל את הדוחות שלכם ב-YAAPS.",
    "platformHeading": "לאיזו תיקייה להעתיק את הסקיל?",
    "requestError": "לא הצלחנו להשלים את הבקשה. בדקו את הקוד ונסו שוב.",
    "reviewScript": "פתיחה ובדיקה של סקריפט ההתקנה",
    "scriptSafety": "הסקריפט מתקין רק את קבצי הסקיל YAAPS. אפשר לפתוח ולבדוק אותו לפני שמריצים את הפקודה.",
    "securityHeading": "איזו גישה הסוכן מקבל",
    "securityText": "אחרי האישור הסוכן מקבל מפתח API פעיל עם שליטה מלאה בדוחות YAAPS של החשבון: יצירת דוחות, צפייה בפרטים ובגרסאות, שינוי כותרות, הפעלה, השבתה ומחיקה לצמיתות. הגישה נשארת פעילה עד שתבטלו את המפתח בהגדרות. המפתח לא מאפשר כניסה לדשבורד, שינוי Passkeys או גישה ל-session בדפדפן.",
    "skillName": "סקיל YAAPS",
    "stepActive": "השלב הנוכחי",
    "stepApprove": "מאשרים",
    "stepAsk": "מבקשים מה-AI להתחבר",
    "stepCommandCopied": "הפקודה הועתקה",
    "stepComplete": "הושלם",
    "stepInstall": "מתקינים את הסקיל",
    "stepInstalled": "הותקן",
    "stepNext": "השלב הבא",
    "stepPromptCopied": "הבקשה הועתקה",
    "stepsLabel": "שלבי החיבור"
  },
  "dashboard": {
    "eyebrow": "מתקינים את הסקיל. מבקשים מהסוכן לפרסם.",
    "featureTexts": [
      "מתקינים פעם אחת את הסקיל YAAPS ומשתמשים בו עם Codex, עם Claude או עם AI אחר שתומך ב-Agent Skills.",
      "כשהדוח מוכן, הסוכן מחזיר קישור שאפשר לפתוח בדפדפן או לשלוח למי שצריך.",
      "ביקשתם שינוי? הסוכן מפרסם גרסה חדשה, והקישור שכבר שיתפתם ממשיך לעבוד."
    ],
    "featureTitles": [
      "סקיל נייד אחד",
      "הסוכן מחזיר קישור",
      "מעדכנים בלי להחליף קישור"
    ],
    "heading": "הסוכן יצר דוח? עכשיו אפשר לשתף אותו.",
    "intro": "מוסיפים את הסקיל YAAPS ל-Codex, ל-Claude או ל-AI תואם אחר. אחר כך מבקשים ממנו בשפה רגילה לפרסם דוח ומקבלים קישור שאפשר לשלוח לכל אחד.",
    "nextHeading": "הדוחות לא נשארים באוויר לנצח",
    "nextText": "ברירת המחדל היא 7 ימים. אפשר לבחור תוקף אחר, להפסיק את השיתוף או למחוק את הדוח בכל רגע.",
    "primaryAction": "איך מחברים סוכן",
    "securityEyebrow": "כשמשתפים עם אחרים",
    "securityHeading": "מי שמקבל את הקישור רואה רק את הדוח.",
    "securityText": "הקישור לא נותן גישה לחשבון שלכם או לדוחות אחרים. סקריפטים, שליחת טפסים, עמודים מוטמעים ובקשות רשת יזומות נשארים חסומים. דוחות מחוברים יכולים לטעון משאבי HTTPS חיצוניים.",
    "secondaryAction": "הדוחות שלי",
    "statusHeading": "איך YAAPS עובד",
    "statusItems": [
      "מתקינים את הסקיל YAAPS",
      "מבקשים מה-AI לפרסם את הדוח עם YAAPS",
      "מאשרים את החיבור הראשון ומקבלים קישור לשיתוף"
    ],
    "terminalLabel": "מה שמבקשים מה-AI",
    "terminalPrompt": "פרסם את הדוח הזה עם $yaaps למשך 24 שעות",
    "terminalPromptBeforeSkill": "פרסם את הדוח הזה עם",
    "terminalPromptAfterSkill": "למשך 24 שעות",
    "terminalResponseLabel": "ה-AI שלכם",
    "terminalSuccess": "הדוח פורסם ב-YAAPS ל-24 שעות.",
    "terminalOpenReport": "פתיחת הדוח",
    "terminalResult": "https://yaaps.net/d/8K2...Qp",
    "terminalExpiresAt": "בתוקף עד",
    "unavailable": "יש לכם חשבון? היכנסו כדי לראות את הדוחות ולנהל את הגישה של הסוכנים שלכם."
  },
  "docs": {
    "authenticationHeading": "אימות",
    "authenticationText": "יוצרים מפתח API בהגדרות ושומרים אותו בסביבת הסודות של האפליקציה. שולחים אותו בכל בקשה מאומתת כ-Bearer token. המפתח המלא מוצג רק פעם אחת, לכן לא שומרים אותו בקוד המקור, בלוגים או בהודעות צ'אט.",
    "endpointDescriptions": {
      "addVersion": "פרסום גרסה חדשה בלי לשנות את הקישור הראשי של הדוח.",
      "categories": "הצגת הקטגוריות שבשימוש בדוחות שלכם, עם מספר הדוחות בכל אחת.",
      "create": "פרסום דוח חדש ממסמך HTML מלא. אפשר להוסיף קטגוריה כדי לקבץ אותו עם דוחות קשורים.",
      "delete": "מחיקה לצמיתות של דוח וכל הגרסאות שלו.",
      "inspect": "קבלת הפרטים של דוח אחד ששייך לחשבון שלכם.",
      "list": "הצגת כל הדוחות ששייכים לחשבון שלכם, עם אפשרות לסנן לפי קטגוריה.",
      "update": "שינוי הכותרת או הקטגוריה, או התחלה והפסקה של שיתוף הדוח.",
      "versions": "הצגת כל הגרסאות של הדוח."
    },
    "endpointsHeading": "Endpoints",
    "endpointsIntro": "הפעולות האלה מאפשרות לפרסם דוחות, להוסיף גרסאות בלתי ניתנות לשינוי, לשלוט בזמינות ולמחוק דוחות. כל מפתח API יכול לגשת רק לדוחות ששייכים לחשבון שלו.",
    "errorHeading": "כשמשהו לא עובד",
    "errorText": "כל שגיאה כוללת קוד קבוע שלקוחות API יכולים לטפל בו והסבר קצר על מה השתבש.",
    "eyebrow": "תיעוד API",
    "heading": "בונים עם ה-API של YAAPS",
    "intro": "מפרסמים ומנהלים דוחות HTML מבודדים או מחוברים דרך HTTP. בתיעוד הפעיל אפשר לבדוק את הסכמה, לנסות פעולות מאומתות או ליצור client.",
    "limitsHeading": "מגבלות",
    "limitsItems": [
      "גודל מרבי לקובץ HTML: 10 MB",
      "תוקף ברירת מחדל: 7 ימים",
      "אפשר לבחור תוקף בין שעה לשנה",
      "עד 100 תוצאות בכל עמוד"
    ],
    "openApiAction": "פתיחת מפרט OpenAPI 3.1",
    "openApiText": "אפשר לעיין בסכמת ה-API המלאה או ליצור ממנה לקוח.",
    "quickStartHeading": "פרסום דוח",
    "quickStartIntro": "מגדירים את כתובת הבסיס של YAAPS ואת מפתח ה-API, ואז שולחים מסמך HTML מלא בגוף הבקשה. connected הוא ברירת המחדל ועשוי לטעון תמונות, גיליונות עיצוב ופונטים חיצוניים ב-HTTPS. בוחרים isolated במפורש כדי לחסום טעינת משאבים חיצוניים. הקטגוריה היא רשות ומקבצת את הדוח עם דוחות קשורים.",
    "redocAction": "קריאת ה-API ב-ReDoc",
    "redocText": "עיון בתיעוד נקי וניתן לחיפוש שנוצר מהמפרט הפעיל.",
    "responseHeading": "תשובת ה-API",
    "securityHeading": "איך YAAPS מגן על מי שפותח את הדוח",
    "securityText": "כל מי שמחזיק בקישור יכול לפתוח את הדוח. דוחות מבודדים חוסמים משאבים חיצוניים. דוחות מחוברים יכולים לטעון תמונות, גיליונות עיצוב ופונטים ב-HTTPS. בשני המצבים נשארים חסומים סקריפטים, שליחת טפסים, מסגרות, תוספים, בקשות רשת יזומות וגישה מסוג same-origin.",
    "tocLabel": "בעמוד הזה",
    "swaggerAction": "בדיקת ה-API עם Swagger UI",
    "swaggerText": "עיון בבקשות והפעלה אינטראקטיבית של פעולות API מאומתות."
  },
  "management": {
    "accepted": "נוצלה",
    "accountHeading": "אבטחת הכניסה",
    "active": "פעיל",
    "adminError": "לא הצלחנו לטעון או לעדכן את נתוני הניהול. נסו שוב.",
    "adminEyebrow": "ניהול",
    "adminHeading": "משתמשים, הזמנות ודוחות",
    "adminIntro": "מזמינים אנשים, בוחרים את רמת הגישה שלהם ומשביתים חשבונות כשצריך. אין צורך להיכנס לחשבון של משתמש אחר.",
    "allReportsHeading": "דוחות מכל המשתמשים",
    "cancel": "ביטול",
    "categoryChoose": "בחירת קטגוריה",
    "categoryClear": "הסרת הקטגוריה",
    "categoryEdit": "שינוי הקטגוריה",
    "categoryFilterAll": "כל הדוחות",
    "categoryFilterLabel": "סינון לפי קטגוריה",
    "categoryFilterOption": "הצגת {category} בלבד ({count})",
    "categoryLabel": "קטגוריה",
    "categoryNew": "קטגוריה חדשה…",
    "categoryNewLabel": "שם הקטגוריה החדשה",
    "categoryPlaceholder": "דוחות שבועיים",
    "categorySave": "שמירת הקטגוריה",
    "categorySet": "הוספת קטגוריה",
    "confirmDelete": "כן, למחוק לצמיתות",
    "confirmDisableUser": "כן, להשבית",
    "confirmRevoke": "כן, לבטל את המפתח",
    "copied": "הועתק",
    "copyKey": "העתקת המפתח",
    "createInvitation": "יצירת קישור הזמנה",
    "createKey": "יצירת מפתח API",
    "delete": "מחיקה",
    "disable": "הפסקת שיתוף",
    "disableUser": "השבתה",
    "draftCount": "דוח",
    "draftsCount": "דוחות",
    "emptyCategoryHeading": "אין דוחות בקטגוריה הזו",
    "emptyCategoryText": "כרגע אין אף דוח בקטגוריה {category}. אפשר לבחור קטגוריה אחרת או להציג את כל הדוחות.",
    "emptyReportsHeading": "עדיין אין כאן דוחות",
    "emptyReportsText": "כשהסוכן שלכם יפרסם דוח ב-YAAPS, הוא יופיע כאן.",
    "enable": "שיתוף מחדש",
    "enableUser": "הפעלה",
    "enabled": "ציבורי",
    "error": "לא הצלחנו להשלים את הבקשה. נסו שוב.",
    "expired": "פג תוקף",
    "expires": "בתוקף עד:",
    "extend": "הארכת תוקף",
    "extendDay": "יום",
    "extendMonth": "30 יום",
    "extendWeek": "שבוע",
    "extendYear": "שנה",
    "eyebrow": "מה שהסוכנים פרסמו",
    "heading": "הדוחות שלי",
    "hideVersions": "הסתרת גרסאות",
    "intro": "כאן אפשר לפתוח דוחות, לראות את כל הגרסאות ולהחליט אילו קישורים ממשיכים לעבוד.",
    "invitationReady": "קישור ההזמנה נוצר",
    "invitationWarning": "העתיקו ושלחו את הקישור עכשיו. הקישור המלא לא יוצג שוב.",
    "inviteHeading": "הזמנת משתמש",
    "inviteRole": "סוג החשבון",
    "keyCount": "מפתח API פעיל",
    "keyLabel": "שם המפתח",
    "keyPlaceholder": "הסוכן במחשב שלי",
    "keyReady": "מפתח ה-API נוצר",
    "keyWarning": "העתיקו אותו עכשיו והגדירו אותו בסביבה שבה הסוכן רץ. המפתח המלא לא יוצג שוב.",
    "keysCount": "מפתחות API פעילים",
    "keysEyebrow": "חיבור הסוכנים",
    "keysHeading": "מפתחות API לסוכנים",
    "lastUsed": "שימוש אחרון:",
    "loading": "טוענים...",
    "neverUsed": "עדיין לא היה בשימוש",
    "openReport": "פתיחת הדוח",
    "owner": "בעלים:",
    "pending": "ממתינה",
    "remaining": "עוד {duration}",
    "rename": "שינוי שם",
    "renameSave": "שמירת השם",
    "reportDisabled": "לא משותף",
    "resourcePolicyConnected": "משאבי HTTPS חיצוניים",
    "resourcePolicyIsolated": "מבודד",
    "reportsEyebrow": "מה שהסוכנים פרסמו",
    "reportsHeading": "דוחות",
    "revoke": "ביטול",
    "revokeInvitation": "ביטול ההזמנה",
    "revoked": "בוטלה",
    "roleAdmin": "מנהל",
    "roleUser": "משתמש",
    "savedInvitation": "סיימתי",
    "savedKey": "סיימתי",
    "settingsEyebrow": "הגדרות החשבון",
    "settingsHeading": "גישה לסוכנים וכניסה לחשבון",
    "settingsIntro": "כאן יוצרים מפתחות API לסוכנים ומוסיפים Passkeys לכניסה לחשבון.",
    "showVersions": "הצגת גרסאות",
    "showingLimited": "מוצגים {shown} האחרונים מתוך {total}.",
    "summary": "מספר הדוחות והמפתחות",
    "untitled": "דוח ללא כותרת",
    "userDisabled": "מושבת",
    "usersHeading": "משתמשים",
    "version": "גרסה",
    "versionsHeading": "גרסאות שמורות",
    "views": "כניסות: {count}"
  },
  "navigation": {
    "administration": "ניהול",
    "ariaLabel": "ניווט ראשי",
    "connect": "חיבור סוכן",
    "dashboard": "הדוחות שלי",
    "docs": "תיעוד API",
    "settings": "הגדרות"
  },
  "product": {
    "footer": "הסוכן מפרסם. אתם משתפים.",
    "name": "YAAPS",
    "tagline": "משתפים דוחות מכל סוכן AI"
  },
  "status": {
    "label": "עובד עם כל סוכן"
  },
  "theme": {
    "dark": "כהה",
    "light": "בהיר"
  },
  "titles": {
    "admin": "ניהול | YAAPS",
    "approve": "אישור חיבור סוכן | YAAPS",
    "connect": "חיבור הסוכן | YAAPS",
    "dashboard": "הדוחות שלי | YAAPS",
    "docs": "תיעוד API | YAAPS",
    "landing": "YAAPS | שיתוף דוחות מכל סוכן AI",
    "login": "כניסה | YAAPS",
    "settings": "הגדרות | YAAPS"
  }
}
